module.exports = __webpack_public_path__ + "img/北京古树游览推荐-故宫.f55ea7f3.jpg";